<template>
    <div v-if="isLoading" class="animate-pulse bg-gray-300/50 dark:bg-gray-300 w-full h-[240px] rounded-[0.5rem]" />
    <section v-else-if="list && list.length > 0" class="p-2 px-2.5 md:p-4 rounded-[0_0_11px_11px] md:rounded-[11px] bg-white">
        <div class="flex flex-col xs:flex-row xs:justify-between xs:items-center pb-4">
            <StoreSectionTitle :title="$t('general.news_and_offers')" />
            <NuxtLink v-if="newsLength > 1" :to="newsLink" class="text-primary hover:text-primary/80 transition-all duration-200 text-[0.9rem] sm:text-[1rem]">{{ $t('general.show_more') }}</NuxtLink>
        </div>
        <div>
            <StoreNewsItem v-for="item in list" :key="item.id" :item="item"  />
        </div>
    </section>
</template>

<script>
import StoreNewsItem from "./StoreNewsItem.vue";
import StoreSectionTitle from "./StoreSectionTitle.vue";
import { ROUTESNAMES } from "@/helpers";

export default {
    data(){
        return {
            ROUTESNAMES
        }
    },
    props: {
        isLoading: {
            type: Boolean,
            required: true,
            default: false
        },
        storeUsername: {
            type: String,
            required: true,
            default: ""
        },
        newsLength: {
            type: Number,
            required: true,
            default: 0
        },
        list: {
            type: Array,
            required: true,
            default: () => ([])
        }
    },
    components: {
        StoreSectionTitle,
        StoreNewsItem
    },
    computed: {
        newsLink(){
            return `${this.ROUTESNAMES.user.store}/${this.storeUsername}/?news=1`;
        }
    }

}
</script>

<style></style>